import { FormProvider, useForm } from "@graphcommerce/ecommerce-ui";
import IconUser from "../icons/IconUser";
import IconUserAdd from "../icons/IconUserAdd";
import LoginForm from "./LoginForm";
import { useState } from "react";
import SignupForm from "./Signup";
import CodeForm from "./CodeForm";
import SendCodeForm from "./SendCodeForm";

type AuthFormsProps = {
  activeForm?: string;
  stayAtPage?: boolean;
}
export default function AuthForms({ activeForm: activeFormProp, stayAtPage }: AuthFormsProps) {
  const [activeForm, setActiveForm] = useState(activeFormProp ?? 'login');
  const [activeTab, setActiveTab] = useState(activeFormProp ?? 'login')
  const [data, setData] = useState({});
  const methods = useForm();
  return (
    <div className="relative min-h-[10rem]">
      <div className="absolute md:top-[-40px] right-0 left-0 flex justify-center">
        <button className={`flex justify-center w-[10rem] h-12 items-center ${activeTab === 'login' ? 'bg-secondary-300 text-white' : 'bg-light-170 '}  rounded-s-sm`} onClick={() => {
          if (activeForm === 'signup') {
            setActiveForm('login')
            setActiveTab('login')
          }
        }}>
          <IconUser className="ml-2" width={14} height={14} />
          <span className="text-sm">ورود</span>
        </button>

        <button className={`flex justify-center w-[10rem] h-12 items-center ${activeTab !== 'login' ? 'bg-secondary-300 text-white' : 'bg-light-170 '}  rounded-e-sm`} onClick={() => {
          if (activeForm === 'login' || activeForm === 'code') {
            setActiveForm('signup');
            setActiveTab('signup')
          }
        }}>
          <IconUserAdd className="ml-2" width={14} height={14} />
          <span className="text-sm">ثبت‌نام</span>
        </button>
      </div>
      <FormProvider {...methods}>

        {activeForm === 'login' && <LoginForm setActiveForm={setActiveForm} stayAtPage={stayAtPage} />}

        {activeForm === 'signup' && <SignupForm setActiveForm={setActiveForm} setData={setData} />}

        {activeForm === 'code' && <CodeForm setActiveForm={setActiveForm} setData={setData} />}

        {activeForm === 'sendcode' && <SendCodeForm setActiveForm={setActiveForm} data={data} stayAtPage={stayAtPage} />}

      </FormProvider>
    </div>
  )
}
